require('./bootstrap');
require('./plugins');

window.flatpickr = require('flatpickr/dist/flatpickr.min')
window.Indonesian = require('flatpickr/dist/l10n/id.js').default.id;
window.moment = require('moment/moment');
window.Chart = require('chart.js/dist/chart');
window.monthSelectPlugin = require('flatpickr/dist/plugins/monthSelect/index')
window.AutoNumeric = require('autonumeric/dist/autoNumeric.min');
window.select2 = require('select2/dist/js/select2.min');

import 'alpinejs';
